import React from "react";
import { CheckCircle, Warning, ChartLineUp, ListChecks } from "@phosphor-icons/react";

const CARDS = [
  { key: "total", label: "Total Tasks", accent: "text-[#0A0A0A]", icon: ListChecks },
  { key: "on_track", label: "On Track", accent: "text-emerald-600", icon: CheckCircle },
  { key: "at_risk", label: "At Risk / Critical", accent: "text-amber-600", icon: Warning },
  { key: "avg_completion", label: "Avg Completion", suffix: "%", accent: "text-indigo-600", icon: ChartLineUp },
];

export default function KpiCards({ stats }) {
  const s = stats || {};
  const values = {
    total: s.total || 0,
    on_track: (s.by_overall_status || {})["On Track"] || 0,
    at_risk:
      ((s.by_overall_status || {})["At Risk"] || 0) +
      ((s.by_overall_status || {})["Critical"] || 0),
    avg_completion: s.avg_completion || 0,
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="kpi-grid">
      {CARDS.map((c) => {
        const Icon = c.icon;
        return (
          <div
            key={c.key}
            data-testid={`kpi-card-${c.key}`}
            className="relative bg-white border border-[#E5E5E5] rounded-lg p-5 hover:border-[#0A0A0A] transition-colors duration-200"
          >
            <div className="flex items-start justify-between">
              <div>
                <p
                  className="text-[10px] uppercase tracking-[0.25em] text-neutral-500 font-semibold"
                  style={{ fontFamily: "IBM Plex Mono, monospace" }}
                >
                  {c.label}
                </p>
                <div className="flex items-baseline gap-1 mt-3">
                  <span
                    className={`text-4xl font-black tracking-tight ${c.accent}`}
                    style={{ fontFamily: "Chivo, sans-serif" }}
                  >
                    {values[c.key]}
                  </span>
                  {c.suffix ? (
                    <span className="text-lg font-bold text-neutral-400">{c.suffix}</span>
                  ) : null}
                </div>
              </div>
              <div className={`h-9 w-9 flex items-center justify-center border border-[#E5E5E5] rounded-md ${c.accent}`}>
                <Icon size={18} weight="bold" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
